import { isWebPushTransportEnabled } from "@/lib/isWebPushTransportEnabled";
import type { WebPushCapability } from "@/lib/web-push-browser";

interface WebPushConfig {
  available?: boolean;
  publicKey?: string | null;
  transports?: { apns: boolean; fcm: boolean };
}

export function isCurrentWebPushAvailable(
  capability: WebPushCapability | null,
  config: WebPushConfig | undefined,
) {
  if (capability?.kind !== "supported" || !config?.available || !config.publicKey) return false;
  return isWebPushTransportEnabled(config.transports, capability.transport);
}
